import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Col, Row, Form, Select, message, Checkbox, Tooltip } from "antd";
import "./style.scss";
import { WorkflowContext, StepContext } from "../../Commons/Context";
import { isObject, keys as keycreate, sample } from "lodash";
import { PrimaryButton } from "../../Commons";
import { requiredRule, flatten } from "../../Commons/utils";
import {
  fetchXeroAccounts,
  fetchXeroBrandingTheme,
  fetchXeroCurrencies,
  fetchXeroItems,
  fetchXeroTaxRates,
} from "../../Http/xero";
import { api } from "../../Http";
import { InfoCircleOutlined } from "@ant-design/icons";

const InvoiceForm = (props) => {
  const {
    sampleData,
    sampleData2,
    setActionData,
    mappings,
    additionalQuery,
    setAdditionalQuery,
    setMappings,
    setOrganisation,
    form,
  } = useContext(WorkflowContext);
  const { id, next } = useContext(StepContext);
  const params = useParams();
  const [workflow, setWorkflow] = useState({});
  const [checkboxStatus, setCheckboxStatus] = useState();

  const [keys, setKeys] = useState([]);
  const [keys2, setKeys2] = useState([]);
  const [accountOpt, setAccountOpt] = useState([]);
  const [currencyOpt, setCurrencyOpt] = useState([]);
  const [brandingThemeOpt, setBrandingThemeOpt] = useState([]);
  const [itemCodeOpt, setItemCodeOpt] = useState([]);
  const [taxRatesOpt, setTaxRatesOpt] = useState([]);
  const [returnMap, setReturnMap] = useState(false);

  const sentToContactOpt = [
    { label: "True", value: true },
    { label: "False", value: false },
  ];

  const lineAmountTypesOpt = [
    { label: "EXCLUSIVE", value: "Exclusive" },
    { label: "INCLUSIVE", value: "Inclusive" },
    { label: "NOTAX", value: "NoTax" },
  ];

  const statusOpt = [
    { label: "DRAFT", value: "DRAFT" },
    { label: "SUBMITTED", value: "SUBMITTED" },
    { label: "AUTHORISED", value: "AUTHORISED" },
  ];

  useEffect(() => {
    if (sampleData) {
      setKeys(keycreate(sampleData));
    }
    if (sampleData2) {
      setKeys2(keycreate(sampleData2));
    }
    // //console.log({mappings, sampleData, sampleData2});
    let tmp = {};
    if (sampleData && sampleData2) {
      mappings?.forEach((v) =>
        v.type === "TRIG" || v.type === "LOG" || v.type === "LOGM" || v.type === "LOGS"
          ? ((tmp[v.field] = [`${v.valueStepOrder}.${v.value}`]),
            (tmp[v.label] =
              v.valueStepOrder === 1
                ? `${v.valueStepOrder}.${v.value}: ${sampleData[v.value]}`
                : `${v.valueStepOrder}.${v.value}: ${sampleData2[v.value]}`))
          : v.type === "ACT"
            ? ((tmp[v.value] = [`${v.valueStepOrder}.${v.field}`]),
              (tmp[v.label] =
                v.valueStepOrder === 1
                  ? `${v.valueStepOrder}.${v.value}: ${sampleData[v.value]}`
                  : `${v.valueStepOrder}.${v.value}: ${sampleData2[v.value]}`))
            : (tmp[v.field] = `${v.value}`),
      );
    } else {
      if (!props.showerror) {
        return;
      } else {
        message.error("Please proceed step by step from the beginning", 3);
      }
    }
    if (tmp) {
      //console.log({temFieldValue:tmp})
      form.setFieldsValue(tmp);
    }
  }, [sampleData, sampleData2]);

  useEffect(() => {
    fetchAccountOpt();
    fetchCurrencyOpt();
    fetchBrandingThemeOpt();
    fetchItemCodeOpt();
    fetchTaxRatesOpt();
  }, []);

  useEffect(() => {
    fetchWokflowByWorkflowId(params?.id);
  }, [params?.id, checkboxStatus]);

  const fetchWokflowByWorkflowId = async (workflowId) => {
    const workflowSingleRes = await api.get(
      `/api/v1/workflows/${workflowId}/rawWorkflowById`,
    );
    if (workflowSingleRes?.data.code === 0) {
      setCheckboxStatus(workflowSingleRes?.data.data.asPdf);
      setWorkflow(workflowSingleRes?.data.data);
    }
  };

  const fetchAccountOpt = async () =>
    setAccountOpt(await (await fetchXeroAccounts()).data);
  const fetchCurrencyOpt = async () =>
    setCurrencyOpt(await (await fetchXeroCurrencies()).data);
  const fetchBrandingThemeOpt = async () =>
    setBrandingThemeOpt(await (await fetchXeroBrandingTheme()).data);
  const fetchItemCodeOpt = async () =>
    setItemCodeOpt(await (await fetchXeroItems()).data);
  const fetchTaxRatesOpt = async () =>
    setTaxRatesOpt(await (await fetchXeroTaxRates()).data);

  const saveAsPdfHandle = (e) => {
    let status;
    if (e.target.checked) {
      status = true;
      setCheckboxStatus(status);
    }
    if (!e.target.checked) {
      status = false;
      setCheckboxStatus(status);
    }
    api.patch(`/api/v1/workflows/${params?.id}/aspdf`, {
      asPdf: status,
    });
  };
  //console.log({workflowData: workflow})

  const handleSubmit = () => {
    form
      .validateFields()
      .then((rawFormData) => {
        let ACTION_DATA = {}; //Data to be send as a product of the trigger
        let MAPPINGS = [];

        let flatFormData = flatten({ ...rawFormData, Type: "ACCREC" }); // add invoice type then flatten

        keycreate(flatFormData)
          .filter((k) => flatFormData[k] && !Array.isArray(flatFormData[k]))
          .map((key) => {
            //key is xero field like Contact.ContactID or LineItems[0].UnitAmount or LineItemID
            let val = flatFormData[key].split("."); // val is salesforce field like ['1', 'Contact_Xero_Id__c']
            let kname = val.length > 1 ? val[1] : val[0];
            let snum = val.length > 1 ? val[0] : undefined;

            let kval =
              snum && parseInt(snum) === 1
                ? sampleData[kname]
                : snum && parseInt(snum) === 2
                  ? sampleData2[kname]
                  : kname;

            if (key !== "Log" && key !== "LogMessage" && key !== "LogStatus") {
              ACTION_DATA = { ...ACTION_DATA, [key]: kval };
            }
            MAPPINGS = snum
              ? key === "InvoiceID"
                ? [
                    ...MAPPINGS,
                    {
                      type: "ACT",
                      field: kname,
                      value: key,
                      stepId: id,
                      valueStepOrder: snum,
                    },
                  ]
                : key === "InvoiceNumber" ||
                    key === "SubTotal" ||
                    key === "TotalTax"
                  ? [
                      ...MAPPINGS,
                      {
                        type: "ACT",
                        field: kname,
                        value: key,
                        stepId: id,
                        valueStepOrder: snum,
                      },
                    ]
                  : key === "LineItemID" ||
                      key === "Total" ||
                      key === "TotalDiscount"
                    ? [
                        ...MAPPINGS,
                        {
                          type: "ACT",
                          field: kname,
                          value: key,
                          stepId: id,
                          valueStepOrder: snum,
                        },
                      ]
                    : key === "LineItems[0].ItemCode"
                      ? [
                          ...MAPPINGS,
                          {
                            type: "ACT",
                            field: kname,
                            value: key?.split(".")[1],
                            stepId: id,
                            valueStepOrder: snum,
                          },
                          {
                            type: "TRIG",
                            field: key,
                            value: kname,
                            stepId: id,
                            valueStepOrder: snum,
                          },
                        ]
                      : key === "Log" || key === "LogMessage" || key === "LogStatus"
                        ? [
                            ...MAPPINGS,
                            {
                              type: key === "Log" ? "LOG" : key === "LogMessage" ? "LOGM" : "LOGS",
                              field: key,
                              value: kname,
                              stepId: id,
                              valueStepOrder: snum,
                            },
                          ]
                        : [
                            ...MAPPINGS,
                            {
                              type: "TRIG",
                              field: key,
                              value: kname,
                              stepId: id,
                              valueStepOrder: snum,
                            },
                          ]
              : key === "InvoiceID"
                ? [
                    ...MAPPINGS,
                    {
                      type: "ACT",
                      field: kname,
                      value: key,
                      stepId: id,
                      valueStepOrder: snum,
                    },
                  ]
                : [
                    ...MAPPINGS,
                    { type: "CON", field: key, value: kname, stepId: id },
                  ];
            return key;
          });

        //console.log({ACTION_DATA});
        //console.log({MAPPINGS});

        //lineitems query generation from form fields
        const lineItemFields = [];
        MAPPINGS.filter((item) => {
          if (item.field.includes("[0]")) {
            lineItemFields.push(item.value);
          }
        });

        let fieldStr = lineItemFields.length > 0 && lineItemFields.join(",");
        fieldStr = fieldStr + ",Id";
        const newQuery = additionalQuery?.replace(/{strFields}/, fieldStr);
        setAdditionalQuery(newQuery);
        setActionData(ACTION_DATA);
        setMappings(MAPPINGS);
        next();
      })
      .catch((e) => console.log(e));
  };

  const RoundedSelect = (props) => {
    const {
      label,
      placeholder,
      name,
      required,
      specialOptions,
      specialOptionsOnly,
      hint,
      onSelect,
      tooltipTitle,
    } = props;

    return (
      <Col span={22}>
        <div className="label">
          {label}
          {tooltipTitle && (
            <Tooltip placement="topLeft" title={tooltipTitle}>
              <span style={{ marginLeft: "2px" }}>
                <InfoCircleOutlined />
              </span>
            </Tooltip>
          )}
          <span className={required ? "fr" : "hidden"}>(required)</span>
        </div>

        <Form.Item
          name={name}
          required={required}
          rules={required ? [requiredRule] : null}
        >
          <Select
            className="rounded"
            mode={specialOptions ? null : "tags"}
            placeholder={placeholder}
            allowClear
            onSelect={onSelect}
          >
            {specialOptions &&
              specialOptions.map((v) => (
                <Select.Option key={v.value} value={v.value}>
                  {v.label}
                </Select.Option>
              ))}

            {!specialOptionsOnly &&
              keys.map(
                (v, k) =>
                  !isObject(sampleData[v]) && (
                    <Select.Option value={`1.${v}`} key={`1.${k}`}>
                      <div className="opt-div">
                        <span className="key">{`1.${v}:  `}</span>
                        {`${sampleData[v]}`}
                      </div>
                    </Select.Option>
                  ),
              )}

            {!specialOptionsOnly &&
              keys2.map(
                (v, k) =>
                  !isObject(sampleData2[v]) && (
                    <Select.Option value={`2.${v}`} key={`2.${k}`}>
                      <div className="opt-div">
                        <span className="key">{`2.${v}:  `}</span>
                        {`${sampleData2[v]}`}
                      </div>
                    </Select.Option>
                  ),
              )}
          </Select>
        </Form.Item>
        {hint && <div className="hint">{hint}</div>}
      </Col>
    );
  };

  const onChange = (event) => {
    //console.log({ event, form: form.getFieldsValue() });
  };

  return (
    <Row className="padded xinvform">
      <div className="title">Customize Sales Invoice</div>
      <Col span={24}>
        <Form
          layout="vertical"
          form={form}
          scrollToFirstError={true}
          onFinish={handleSubmit}
          onValuesChange={onChange}
        >
          <Row hidden={returnMap} justify="center">
            <RoundedSelect
              label="Contact Xero Id"
              name="Contact.ContactID"
              required={true}
              placeholder="Type or insert.."
            />
            <RoundedSelect
              label="Email Address"
              name="Contact.EmailAddress"
              placeholder="Type or insert.."
            />
            <RoundedSelect
              label="Status"
              tooltipTitle="Defaults to Draft if not specified."
              name="Status"
              placeholder="Choose value.."
              specialOptions={statusOpt}
            />
            <RoundedSelect
              label="Amount Paid"
              tooltipTitle="Sum of payments received for invoice."
              name="AmountPaid"
              placeholder="Type or insert.."
            />
            <RoundedSelect
              label="Amount Due"
              tooltipTitle="Amount remaining to be paid on invoice."
              name="AmountDue"
              placeholder="Type or insert.."
            />
            <RoundedSelect
              label="Date"
              tooltipTitle="Defaults to creation date if not specified."
              name="Date"
              placeholder="Type or insert.."
            />
            <RoundedSelect
              label="Due Date"
              tooltipTitle="A due date is required for approved invoices."
              name="DueDate"
              placeholder="Type or insert.."
            />
            <RoundedSelect
              label="Currency"
              tooltipTitle="Default currency for organization will be used if not specified."
              name="CurrencyCode"
              placeholder="Choose value.."
              specialOptions={currencyOpt}
            />
            <RoundedSelect
              label="URL"
              name="Url"
              tooltipTitle="URL link to a source document."
              placeholder="Type or insert.."
            />
            <RoundedSelect
              label="Branding Theme"
              tooltipTitle="The branding theme to use for this invoice."
              name="BrandingThemeId"
              placeholder="Choose value.."
              specialOptions={brandingThemeOpt}
            />
            <RoundedSelect
              label="Number"
              name="InvoiceNumber"
              tooltipTitle="Unique alpha numeric code identifying invoice - leave blank for auto-generated value."
              placeholder="Type or insert.."
            />

            <RoundedSelect
              label="Reference"
              name="Reference"
              tooltipTitle="An additional reference number"
              placeholder="Type or insert.."
            />
            <RoundedSelect
              label="Sent to Contact"
              tooltipTitle="Mark invoice as 'sent' (note: does not actually send an email). This can be set only on invoices that have a status of 'approved' You can set this in the Status field above."
              name="SentToContact"
              placeholder="Type or insert.."
              specialOptions={sentToContactOpt}
            />
            <RoundedSelect
              label="Line Items Type"
              tooltipTitle="Line amounts are exclusive of tax by default if you don't specify this element."
              name="LineAmountTypes"
              placeholder="Choose value.."
              specialOptions={lineAmountTypesOpt}
            />
          </Row>

          <fieldset
            hidden={returnMap}
            className="fieldset"
            style={{ border: "1px solid #e2e2e2" }}
          >
            <legend>Line Items</legend>
            <Row justify="center">
              <RoundedSelect
                label="Item Code"
                tooltipTitle="You must provide either an Item Code or both a Description and a Unit Price."
                //required={true}
                name="LineItems[0].ItemCode"
                placeholder="Choose value.."
                specialOptions={itemCodeOpt}
              />
              <RoundedSelect
                label="Description"
                tooltipTitle="If no Item Code is provided, this field is required."
                name={"LineItems[0].Description"}
                placeholder="Type or insert.."
              />
              <RoundedSelect
                label="Quantity"
                name="LineItems[0].Quantity"
                required={true}
                placeholder="Type or insert.."
              />
              <RoundedSelect
                label="Unit Price"
                tooltipTitle="If no Item Code is provided, this field is required."
                name="LineItems[0].UnitAmount"
                required={true}
                placeholder="Type or insert.."
              />
              <RoundedSelect
                label="Discount%"
                name="LineItems[0].DiscountRate"
                placeholder="Type or insert.."
              />
              <RoundedSelect
                label="Account"
                name="LineItems[0].AccountCode"
                placeholder="Choose value.."
                specialOptions={accountOpt}
              />
              <RoundedSelect
                label="Tax Rate"
                tooltipTitle="Only specify if you want to override the default tax type for the account above."
                name={["LineItems[0].TaxtType"]}
                placeholder="Choose value.."
                specialOptions={taxRatesOpt}
              />
              <RoundedSelect
                label="Tracking Category ID 1"
                tooltipTitle="Xero identifier for the line item's tracking category."
                name="LineItems[0].Tracking[0].TrackingCategoryID"
                placeholder="Type or insert.."
              />
              <RoundedSelect
                label="Tracking Option ID 1"
                tooltipTitle="Xero identifier for an option in the selected tracking category."
                name="LineItems[0].Tracking[0].TrackingOptionID"
                placeholder="Type or insert.."
              />
              <RoundedSelect
                label="Tracking Category ID 2"
                tooltipTitle="Xero identifier for the second line item's tracking category."
                name="LineItems[0].Tracking[1].TrackingCategoryID"
                placeholder="Type or insert.."
              />
              <RoundedSelect
                label="Tracking Option ID 2"
                tooltipTitle="Xero identifier for an option in the second line item's tracking category."
                name="LineItems[0].Tracking[1].TrackingOptionID"
                placeholder="Type or insert.."
              />
            </Row>
          </fieldset>

          <PrimaryButton
            hidden={returnMap}
            className="btn-long"
            size="large"
            htmlType="button"
            onClick={() => setReturnMap(true)}
          >
            Continue
          </PrimaryButton>

          <Row hidden={!returnMap} justify="center">
            <RoundedSelect
              label="InvoiceID"
              name="InvoiceID"
              required={true}
              placeholder="Type or insert Xero_Id"
            />
            <RoundedSelect
              label="InvoiceNumber"
              name="InvoiceNumber"
              required={true}
              placeholder="Type or insert Invoice_Number"
            />
            <RoundedSelect
              label="LineItemID"
              name="LineItemID"
              required={true}
              placeholder="Type or Line_Item_Id"
            />
            <RoundedSelect
              label="Sub Total"
              tooltipTitle="Total of invoice excluding taxes."
              name="SubTotal"
              placeholder="Type or insert.."
            />
            <RoundedSelect
              label="Total Tax"
              name="TotalTax"
              placeholder="Type or insert.."
            />
            <RoundedSelect
              label="Total"
              name="Total"
              placeholder="Type or insert.."
            />
            <RoundedSelect
              label="Total Discount"
              name="TotalDiscount"
              placeholder="Type or insert.."
            />
            <RoundedSelect
              label="Save Error or Success Log Status"
              name="LogStatus"
              placeholder="Select a Salesforce text field"
              hint="Optional. Saves SUCCESS when the invoice sync succeeds, or ERROR when it fails. Use this for a simple status field."
            />
            <RoundedSelect
              label="Save Error or Success Full Log"
              name="Log"
              placeholder="Select a Salesforce text field"
              hint="Optional. Saves the complete response or error details for troubleshooting, up to 131,072 characters. Use a long text field."
            />
            <RoundedSelect
              label="Save Error or Success Message"
              name="LogMessage"
              placeholder="Select a Salesforce text field"
              hint="Optional. Saves the specific validation error when available, or the response message or status on success. Use this for a short readable message."
            />
            <Checkbox
              checked={checkboxStatus ? true : false}
              onChange={saveAsPdfHandle}
              className="custom-checkbox"
            >
              Save Invoice as Pdf to Salesforce
            </Checkbox>

            <PrimaryButton
              hidden={!returnMap}
              className="btn-long"
              size="large"
              htmlType="submit"
            >
              Continue
            </PrimaryButton>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default InvoiceForm;
